/**
 * Number of accepted/rejected offer of customers by four Underwriting/ Re-underwriting results, by whether the Inusred Person is newly insured through Migration
 */

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
		{ s: { r: 1, c: 0 }, e: { r: 3, c: 0 } },
		{ s: { r: 1, c: 1 }, e: { r: 1, c: 8 } },
		{ s: { r: 1, c: 9 }, e: { r: 1, c: 16 } },
		{ s: { r: 2, c: 1 }, e: { r: 2, c: 2 } },
		{ s: { r: 2, c: 3 }, e: { r: 2, c: 4 } },
		{ s: { r: 2, c: 5 }, e: { r: 2, c: 6 } },
		{ s: { r: 2, c: 7 }, e: { r: 2, c: 8 } },
		{ s: { r: 2, c: 9 }, e: { r: 2, c: 10 } },
		{ s: { r: 2, c: 11 }, e: { r: 2, c: 12 } },
		{ s: { r: 2, c: 13 }, e: { r: 2, c: 14 } },
		{ s: { r: 2, c: 15 }, e: { r: 2, c: 16 } }
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template A3 - Number of accepted/rejected offer of customers by four Underwriting/ Re-underwriting results, by whether the Inusred Person is newly insured through Migration"
	],
	["Status", "Standard Plan", "", "", "", "", "", "", "", "Flexi Plan"],
	[
		"",
		"Standard Offer",
		"",
		"Offer with Premium Loading only",
		"",
		"Offer with CBE only",
		"",
		"Offer with Premium Loading and CBE",
		"",
		"Standard Offer",
		"",
		"Offer with Premium Loading only",
		"",
		"Offer with CBE only",
		"",
		"Offer with Premium Loading and CBE",
		""
	],
	[
		"",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject"
	]
]

const rows = payload => [
	["Newly Insured", "", "", "", "", "", "", "", ""],
	[
		"Insured through Migration (who require new application)",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		""
	]
]
